import React from "react";

import StyledUserCard from "./styles";
import { Typography, Button } from "@mui/material";
import UserPicture from "../user-picture";
import SchoolIcon from "@mui/icons-material/School";

const GroupCard = (props) => {
  const { name, university, onUserClick, buttonText, picture } = props;

  const onUserClickHandler = () => {
    if (onUserClick) {
      onUserClick(props);
    }
  };

  return (
    <StyledUserCard onClick={onUserClickHandler}>
      <div className="group-card-cont">
        <div className="group-card-header">
          <div className="group-card-title">
            {picture && <UserPicture src={picture} />}
            {name && (
              <Typography variant="h7" fontWeight={500}>
                {name}
              </Typography>
            )}

            {university && (
              <div className="group-card-uni">
                <SchoolIcon sx={{ width: 20, height: 20 }} />
                <Typography variant="caption">{university}</Typography>
              </div>
            )}
          </div>
        </div>

        {buttonText && (
          <div>
            <Button>{buttonText}</Button>
          </div>
        )}
      </div>
    </StyledUserCard>
  );
};

export default GroupCard;
